// import axios from "./index";

// class AuthApi {
//   static Login = (data) => {
//     return axios.post(`${base}/login`, data);
//   };
// //http://localhost:5057/api/EmployeePortal/login
//   static Register = (data) => {
//     return axios.post(`/register`, data);
//   };

//   static Register = (data) => {
//     return axios.post(`${base}/register`, data);
//   };


// // static Logout = () => {
// //   return axios.post(`${base}/logout`, {}, {
// //     withCredentials: true 
// //   });
//   static Logout = () => {
//   return axios.post(`/logout`, {}, {
//     withCredentials: true 
//   });
// };

//   static GetLoans = (data) => {
//     return axios.get(`/Loan/GetLoans`);
//   }
// }

// //let base = "EmployeePortal";

// export default AuthApi;
import axios from "./index";
import { API_SERVER } from "../config/constant";

class AuthApi {
  static Login = (data) => {
    console.log("API_SERVER:", API_SERVER);
    console.log("Login data:", data);
    return axios.post(`${API_SERVER}EmployeePortal/login`, data);
  };

  static Register = (data) => {
    return axios.post(`${API_SERVER}EmployeePortal/register`, data);
  };

  static Logout = () => {
    return axios.post(`${API_SERVER}EmployeePortal/logout`, {}, {
      withCredentials: true 
    });
  };

  static GetLoans = () => {
    return axios.get(`${API_SERVER}Loan/GetLoans`);
  };

  static ForgotPassword = (data) => {
    return axios.post(`${API_SERVER}EmployeePortal/forgotPassword`, data);
  };
}

export default AuthApi;